import { render } from "./TubeTable.vue?vue&type=template&id=4bc8da30&scoped=true"
import script from "./TubeTable.vue?vue&type=script&lang=js"
export * from "./TubeTable.vue?vue&type=script&lang=js"

import "./TubeTable.vue?vue&type=style&index=0&id=4bc8da30&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc8da30"]])

export default __exports__